<template>
  <div>
    <b-table striped hover sticky-header="1200px" :small="true" :busy="isBusy" :items="items" :fields="fields" :style="rowClass">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- A custom formatted column -->
      <template #cell(last_pct)="data">
        <div :style="getPercentStyle(data.value)">{{ data.value }}</div>
      </template>
      <template #cell(rank_diff)="data">
        <div :style="getPercentStyle(data.value)">{{ data.value }}</div>
      </template>
      <template #cell(symbol_name)="data">
        <div @click="showKline(data.item.symbol_code)">{{ data.value }}</div>
      </template>
      <template #cell(symbol_code)="data">
        <div @click="showKline(data.value)">{{ data.value }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'PopularTable',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isBusy: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'rank',
          sortable: true
        },
        {
          key: 'rank_diff',
          label: 'diff',
          sortable: true,
        },
        {
          key: 'symbol_name',
          label: 'symbol',
          sortable: true,
        },
        {
          key: 'symbol_code',
          label: 'code',
          sortable: true,
        },
        {
          key:'last_pct',
          label: 'pct',
          sortable: true,
        },
        {
          key: 'circulation_value',
          label: '流通',
          sortable: true
        },
      ]
    }
  },
  methods: {
    showKline(symbolCode) {
      this.$emit('show-kline', symbolCode);
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      return this.getPercentStyle(item.last_pct)
    },
    getGradientColor(startColor, endColor, percent) {
      // strip the leading # if it's there
      startColor = startColor.replace(/^\s*#|\s*$/g, '');
      endColor = endColor.replace(/^\s*#|\s*$/g, '');
    
      // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
      if (startColor.length == 3) {
        startColor = startColor.replace(/(.)/g, '$1$1');
      }
    
      if (endColor.length == 3) {
        endColor = endColor.replace(/(.)/g, '$1$1');
      }
    
      // get colors
      function parse(rgb, i) {
        return parseInt(rgb.substr(i, 2), 16)
      }
    
      let startR = parse(startColor, 0),
          startG = parse(startColor, 2),
          startB = parse(startColor, 4);
    
      let endR = parse(endColor, 0),
          endG = parse(endColor, 2),
          endB = parse(endColor, 4);
    
      // calculate new color
      let r = endR - startR;
      let g = endG - startG;
      let b = endB - startB;
    
      r = ((r * percent) + startR)
      g = ((g * percent) + startG)
      b = ((b * percent) + startB)
    
      function hex(x) {
        let h = x.toString(16).split('.')[0].toUpperCase()
        return (h.length == 1) ? '0' + h : h
      }
    
      return '#' + hex(r) + hex(g) + hex(b)
    },
    getPercentColor(pt) {
      if (pt >= 0) {
        if (pt > +10) {
          pt = +10;
        }
        pt = +pt / 10;
        return this.getGradientColor('#FFFFFF', '#FB1023', pt)
      } else {
        if (pt < -10) {
          pt = -10;
        }
        pt = -pt / 10;
        return this.getGradientColor('#FFFFFF', '#278B22', pt)
      }
    },
    getPercentStyle(pt) {
      return {
        'background': this.getPercentColor(pt)
      }
    },
  }
}
</script>

<style scoped>
/* 可以添加组件特定的样式 */
</style>